import { Tolgee, DevTools, VueTolgee, LanguageDetector } from '@tolgee/vue'
import { FormatIcu } from '@tolgee/format-icu'
import { createApp } from 'vue'

import type { TolgeeOptions } from '@tolgee/vue'

import App from './App.vue'
import router from './router'

// Styles
import './assets/styles/style.scss'
import '@synergy/ui-kit-vue3/dist/ui-kit.style.css'

const appNamespace = `verification_front`

const tolggeOptions: TolgeeOptions = {
  defaultLanguage: 'ru',
  apiUrl: import.meta.env.VITE_PUBLIC_TOLGEE__API_URL,
  apiKey: import.meta.env.VITE_PUBLIC_TOLGEE__API_KEY,
  ns: [appNamespace, 'global_front'],
  defaultNs: appNamespace,
  fallbackNs: 'global_front',
  availableLanguages: ['en', 'ru'],
}

if (import.meta.env.MODE === 'production') {
  tolggeOptions.staticData = {
    'ru:global_front': () => import('./locale/global_front/ru.json'),
    [`ru:${appNamespace}`]: () => import('./locale/service_front/ru.json'),
    'en:global_front': () => import('./locale/global_front/en.json'),
    [`en:${appNamespace}`]: () => import('./locale/service_front/en.json'),
  }
}

const tolgee = Tolgee().use(LanguageDetector()).use(DevTools()).use(FormatIcu()).init(tolggeOptions)

const app = createApp(App)

app.use(router)
app.use(VueTolgee, { tolgee })

app.mount('#verification')
